export const TourFakeChannelList = [
    {
        id: 1086,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l79FVckie4j9WT-4cEW6iu3gPd4GivQf_XNSWg=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie",
        country: "US",
        channelType: "Entertainment",
        videoCount: 4025,
        subscriberCount: 102000000,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 259735261,
        monthViewRate: 1.1,
        recentAvgViewCount: 4587983,
        recentAvgEngageRate: 8.7,
        isCheck: true
    },
    {
        id: 5526821,
        avatar:
            "https://yt3.ggpht.com/Yvyb9wgwQt2p-EMtUMoJ8_hE6jMAmmH4W5YnzIEbB16GZrTFBtimTqKU7FiEEZNGyXOVssP8Sg=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie - Topic",
        country: "",
        channelType: "Music",
        videoCount: 6,
        subscriberCount: 145000,
        monthSubscriberCount: 2000,
        monthSubscriberRate: 1.4,
        monthViewCount: 4558,
        monthViewRate: 1.5,
        recentAvgViewCount: 53131,
        recentAvgEngageRate: 2.1,
        isCheck: false
    },
    {
        id: 1224845,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l78XCJQ1C6h9-vKFccM__55wWZ9SeQ27F3tK4g=s240-c-k-c0xffffffff-no-rj-mo",
        title: "Pewdiepie en Español",
        country: "MX",
        channelType: "Entertainment",
        videoCount: 168,
        subscriberCount: 101000,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 6898,
        monthViewRate: 0.1,
        recentAvgViewCount: 33854,
        recentAvgEngageRate: 4.1,
        isCheck: false
    },
    {
        id: 26309,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l78Mdp8ZmJh5CmRIHs1ur73dlUWZttwabvwm=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie Clips",
        country: "",
        channelType: "Gaming",
        videoCount: 73,
        subscriberCount: 90200,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 38602,
        monthViewRate: 1.3,
        recentAvgViewCount: 73186,
        recentAvgEngageRate: 5.4,
        isCheck: false
    },
    {
        id: 20821093,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7_t2h0DWu-ZDWsdblm_XTqqhExb6j4oW-Qi2w=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie's Pie",
        country: "US",
        channelType: "Comedy",
        videoCount: 680,
        subscriberCount: 44300,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 586430,
        monthViewRate: 47.9,
        recentAvgViewCount: 2074,
        recentAvgEngageRate: 10.4,
        isCheck: false
    },
    {
        id: 4032593,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7-1nLrlUnbiiLcgh5TX1Ojb4Px7wOG8ZWtJFw=s240-c-k-c0xffffffff-no-rj-mo",
        title: "suscribete a PewDiePie",
        country: "PE",
        channelType: "Entertainment",
        videoCount: 88,
        subscriberCount: 27500,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 36718,
        monthViewRate: 1.2,
        recentAvgViewCount: 30500,
        recentAvgEngageRate: 9.6,
        isCheck: false
    },
    {
        id: 19931471,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l78LM4-T-aTurDL51rx0S5CEZuaPGUTEKyRAvg=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie Livestreams",
        country: "",
        channelType: "People & Blogs",
        videoCount: 16,
        subscriberCount: 15700,
        monthSubscriberCount: 1900,
        monthSubscriberRate: 13.8,
        monthViewCount: 137128,
        monthViewRate: 17.7,
        recentAvgViewCount: 57032,
        recentAvgEngageRate: 2.6,
        isCheck: false
    },
    {
        id: 26311,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l78_1tHSIJ2xdRMbih1r56Lb5_Gg3l7fva56fQ=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie Sucks !!",
        country: "",
        channelType: "People & Blogs",
        videoCount: 54,
        subscriberCount: 14900,
        monthSubscriberCount: 100,
        monthSubscriberRate: 0.7,
        monthViewCount: 28167,
        monthViewRate: 0.5,
        recentAvgViewCount: 26416,
        recentAvgEngageRate: 19.9,
        isCheck: false
    }
];
export const TourFakeSelectedCreators = [
    {
        id: 1086,
        avatar:
            "https://yt3.ggpht.com/a/AGF-l79FVckie4j9WT-4cEW6iu3gPd4GivQf_XNSWg=s240-c-k-c0xffffffff-no-rj-mo",
        title: "PewDiePie",
        country: "US",
        channelType: "Entertainment",
        videoCount: 4025,
        subscriberCount: 102000000,
        monthSubscriberCount: 0,
        monthSubscriberRate: 0,
        monthViewCount: 259735261,
        monthViewRate: 1.1,
        recentAvgViewCount: 4587983,
        recentAvgEngageRate: 8.7,
        isCheck: true
    },
];
export const TourFakeVideolList = [
    {
        viewCount: 177639,
        engageRate: 4.3,
        videoId: "00fwLZU9pTQ",
        title: "No Makeup Makeup FAIL!",
        publishedAt: "2018-10-01 17:01:29",
        description:
            "Hey my beauties! I tried to do a No Makeup Makeup tutorial but failed miserably, it's soooo hard OMG! I absolutely love the No Makeup Makeup look but I just can't help loving lashes and highlighter too!  I thought the look was really cute so wanted to share it with you guys anyway! I will master the no makeup makeup technique and share an updated tutorial with you guys soon! Has this ever happened to anyone else, I literally couldn't help putting more makeup on, OOPS! Thanks for watching, I love you all so much! xxx\n\nMORE VIDEOS: \n\nMY FAVORITE NEW NUDE LOOK: https://www.youtube.com/watch?v=bIZF_vu6CT8&t=9s \n\nCOLLAB WITH LEA ELUI: https://youtu.be/JTqQTY_KW4E\n\n\nLET\"S BECOME FAMILY!\nSnapchat: HudaBeauty \\ \u0635\u0641\u062d\u0629 \u0633\u0646\u0627\u0628 \u0634\u0627\u062a\nBlog: http://hudabeauty.com \\ \u0627\u0644\u0645\u062f\u0648\u0651\u0646\u0629 \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u0651\u0629\nhttp://instagram.com/hudabeauty \\ \u0635\u0641\u062d\u0629 \u0627\u0644\u0627\u0646\u0633\u062a\u0642\u0631\u0627\u0645\nhttp://facebook.com/hudabeauty\\ \u0635\u0641\u062d\u0629 \u0627\u0644\u0641\u0627\u064a\u0633\u0628\u0648\u0643",
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7-XlH0PbbJmvxsNP1SxBd4D8_1Cq9cJA7Tbhw=s240-c-k-c0xffffffff-no-rj-mo",
        subscriberCount: 3650000,
        thumbnail: "https://i.ytimg.com/vi/00fwLZU9pTQ/mqdefault.jpg",
        channelTitle: "Huda Beauty",
        channelPk: 27095,
        channelId: "UCRSvEADlY-caz3sfDNwvR1A"
    },
    {
        viewCount: 3371676,
        engageRate: 2.1,
        videoId: "_UgIyz2h2N8",
        title: "4 Levels Of Makeup: Amateur to Professional Makeup Artist",
        publishedAt: "2019-06-04 23:51:43",
        description:
            "I challenged makeup artists of four different levels to do the same exact makeup look- an amateur, me (rclbeauty101), a YouTube beauty guru, and a celebrity professional makeup artist \nWho\u2019s makeup was the best/which makeup look looks the most like how you would do It?\n\nAmateur Makeup Artist: https://www.instagram.com/natalie_alonzo/?hl=en\nYouTube beauty guru: https://www.youtube.com/user/nicoleconx3\nProfessional makeup artist: https://www.instagram.com/styledbyhrush/?hl=en\n\nOther Makeup videos I Did:\nDoing My Makeup In 5000 Pounds of Jello With James Charles!\nhttps://www.youtube.com/watch?v=eGhsWJgbuzg&t=1s\nDoing My Makeup In ZERO GRAVITY!\nhttps://www.youtube.com/watch?v=lQMKf4XPkg4\nHot Pepper Makeup Challenge With LaurDiy!\nhttps://www.youtube.com/watch?v=luKY6XN9frM",
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7_Ktq-iN4k8MzySuw9Espnl8ShA_9swUHDIlQ=s240-c-k-c0xffffffff-no-rj-mo",
        subscriberCount: 14400000,
        thumbnail: "https://i.ytimg.com/vi/_UgIyz2h2N8/mqdefault.jpg",
        channelTitle: "Rclbeauty101",
        channelPk: 5982,
        channelId: "UCB0d0JLn1WcGYcwwZ87d2LA"
    },
    {
        viewCount: 1352327,
        engageRate: 5.0,
        videoId: "ezaRPmtD0OU",
        title: '"NO MAKEUP" MAKEUP COLLECTION ... Try-On Review',
        publishedAt: "2019-06-19 17:00:05",
        description:
            "Today I'm testing expensive makeup to look like no makeup ????????\u200d\u2640\ufe0f Perricone MD \"No Makeup\" collection.\nxo's ~ Tati \n???? HALO Before & After PHOTOS HERE \u00bb \u00bb \u00bb https://halobeauty.com/pages/halo-glow\n\n\n\u2714P R O D U C T S  M E N T I O N E D \n\nPerricone No Makeup Foundation Serum $60\rPerricone No Makeup Bronzer $35\r\nPerricone No Makeup Highlighter $35 \r\nPerricone No Makeup Blush $35\r\nPerricone No Makeup Mascara $30\n\n\u2714M A K E U P  W O R N\n \r\nFace: \r\nTarte Smoothing Primer \r\nPerricone No Makeup Foundation // Light Warm \rPerricone No Makeup Bronzer \rPerricone No Makeup Blush \rPerricone No Makeup Highlight \n\r*Added after initial try on \r\nJeffree Star Magic Concealer // C7\rJeffree Star Magic Powder // Beige \rMAC Studio Fix Contour Palette // Light \rHonest Beauty Cream Blush // Rose Pink \rFenty Diamond Bomb // How Many Carats?!\n\rEYES: \r\nMAC Painterly Paint Pot \r\nJouer Tan Lines Shadow Palette \rHuda Melted Shadows // Gold Chains \rPerricone No Makeup Mascara \n\rLIPS: \r\nSorme Lipliner // Nectar \r\nDose Of Colors Lipstick // Glazed \rGlow Gloss // Cupcake \r\n\nNAILS: \r\nGlitter Daze // Grunge \r\nHK Girl Fast Dr Top Coat \n\nLIPS:\nSorme Smearproof Lipliner // Nectar 21\nDose Of Colors Lipstick // Brulee \nGlo Skin Beauty Gloss // Cupcake \n\nSunscreen Mentioned = Elta MD \n\n\n\u2714 S N A P C H A T\nhttps://www.snapchat.com/add/TatiWestbrook\n\n\u2714 I N S T A G R A M\nhttp://instagram.com/glamlifeguru\n\n\u2714 T W I T T E R\nhttp://twitter.com/#!/glamlifeguru\n\n\u2714 F A C E B O O K\nhttp://facebook.com/GlamLifeGuru\n\n\u2714 E M A I L\nTati@GlamLifeGuru.com\n\n\n\nFTC DISCLAIMER:  This video is Not Sponsored & there are no affiliate links.\n\n\n\n\u2714 WRITE TO ME HERE\nTati Westbrook\n1905 Wilcox Ave\nSuite #111\nLos Angeles, CA  90068\n\n\nAll Rights Reserved \u00a9 2019, Tati Westbrook \n\n\n\n\n\n\n\nHi I'm Tati from GlamLifeGuru, thank you for watching my video, please be sure to check out my collection of makeup videos where you'll find my best beauty tips, tricks and favorites on everything from top luxury cosmetics to my favorite drugstore makeup. Whether you're looking for a new product review, tutorial, beauty tip, haul or perhaps even a giveaway, I hope you enjoy watching.",
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7_Gb7q4CiMk_bETLsAOC6G5JM4K6eZbGRkaKQ=s240-c-k-c0xffffffff-no-rj-mo",
        subscriberCount: 9720000,
        thumbnail: "https://i.ytimg.com/vi/ezaRPmtD0OU/mqdefault.jpg",
        channelTitle: "Tati",
        channelPk: 5924827,
        channelId: "UC4qk9TtGhBKCkoWz5qGJcGg"
    },
    {
        viewCount: 13441,
        engageRate: 2.1,
        videoId: "caH2gktsDVU",
        title:
            "\u0905\u0917\u0930 \u092f\u0947 \u0918\u0930\u0947\u0932\u0942 \u0928\u0941\u0938\u094d\u0916\u0947 \u0905\u092a\u0928\u093e\u090f\u0902\u0917\u0947 \u0924\u094b \u0939\u094b \u091c\u093e\u0913\u0917\u0947 \u0939\u093f\u0930\u094b\u0907\u0928\u094b\u0902 \u0938\u0947 \u092d\u0940 \u091c\u094d\u092f\u093e\u0926\u093e \u0938\u0941\u0902\u0926\u0930 \u092c\u093f\u0928\u093e makeup \u0915\u0947\u0964",
        publishedAt: "2019-05-31 08:30:02",
        description:
            "\u091c\u093e\u0928\u093f\u090f \u092c\u093f\u0928\u093e \u092e\u0947\u0915\u0905\u092a \u0915\u0947 \u0938\u0941\u0928\u094d\u0926\u0930 \u0926\u093f\u0916\u0928\u0947 \u0915\u093e \u0930\u093e\u091c, bina makeup ke sundar kaise dikhe | How to Look Beautiful Without Makeup/ Tips & Tricks, Look Beautiful with No Makeup\nIn this Video, I will tell you \u092c\u093f\u0928\u093e \u092e\u0947\u0915\u0905\u092a \u0915\u0947 \u0938\u0941\u0928\u094d\u0926\u0930 \u0926\u093f\u0916\u0928\u0947 \u0915\u093e \u0930\u093e\u091c-  \u092e\u0947\u0915\u0905\u092a \u0915\u0947 \u092c\u093f\u0928\u093e \u0938\u0941\u0902\u0926\u0930 \u0915\u0948\u0938\u0947 \u0926\u093f\u0916\u0947  Makeup Ke Bina Sundar Kaise Dikhe janane ke liye ye video dekhe. Video Hindi me hai, how to look beautiful and attractive in hindi\n\n\uff2c\uff29\uff2b\uff25 | \uff23\uff2f\uff2d\uff2d\uff25\uff2e\uff34 | \uff33\uff28\uff21\uff32\uff25 | \uff33\uff35\uff22\uff33\uff23\uff32\uff29\uff22\uff25 \n& Must Click on notification bell. \nhttp://www.youtube.com/healthtime?sub_confirmation=1\nPlease Like our facebook Page. https://www.facebook.com/healthtime1",
        avatar:
            "https://yt3.ggpht.com/a/AGF-l79eH2dz81ASIYqRcyoQ8WpbabgTiOWXnbFWGA=s240-c-k-c0xffffffff-no-rj-mo",
        subscriberCount: 9050000,
        thumbnail: "https://i.ytimg.com/vi/caH2gktsDVU/mqdefault.jpg",
        channelTitle: "Health Time",
        channelPk: 17202,
        channelId: "UCPMqs8vxEwbie26nFA3ykAw"
    },
    {
        viewCount: 147008,
        engageRate: 5.1,
        videoId: "w6Kym-7gPi8",
        title: "INSTAGRAM BADDIE MAKEUP DONE BY GUYS WITH NO MAKEUP EXPERIENCE",
        publishedAt: "2019-05-20 23:28:41",
        description:
            "INSTAGRAM BADDIE MAKEUP / ASIAN GIRL MAKEUP is what we're doing today. We're doing an ABG Makeup transformation on three of our Chinese friends and seeing if we can unleash the power of makeup. ABG is basically Insta Baddie look.\n\nWe're not following any like asian makeup tutorial or anything so it'll be an interesting makeup before and after look. \n\nABG Makeup is different cause it's more of an Asian American makeup look. It differs from Chinese makeup transformations. It's an asian girl makeup look we've seen a lot here, and we especially see it as like a night out makeup look. Especially in 2019. \n\nAfter this, I wish we had some kind of asian eye makeup tutorial to follow cause eyes are really hard to do. Or at least some kind of makeup hacks. Don't expect the transformation to be on the same level as those viral asian makeup transformation videos haha. \n\nOn the topic of makeup transformations, is anyone else following the James Charles Makeup Drama? It's pretty juicy drama.\n\n\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\n\u2605 F O L L O W  C A N T O M A N D O ????\n\n???????? S U B S C R I B E: https://tinyurl.com/ksxalam\n\n????I N S TA G R A M: https://instagram.com/cantomando\n\n????F A C E B O O K: https://www.facebook.com/CantoMando1/\n\n????M E R C H: https://familytimecm.com\n\n???? P A T R E O N: https://www.patreon.com/cantomando\n\n???? S K I T  C H A N N E L: https://goo.gl/xquB5M\n\n???? B I L I B I L I: https://space.bilibili.com/168422805/\n\n???? W E I B O: https://www.weibo.com/u/6495220878\n\n\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac\u25ac",
        avatar:
            "https://yt3.ggpht.com/a/AGF-l7_tIKwWmix_LlKDEO29BfdpAxg5nL5oSQrFug=s240-c-k-c0xffffffff-no-rj-mo",
        subscriberCount: 298000,
        thumbnail: "https://i.ytimg.com/vi/w6Kym-7gPi8/mqdefault.jpg",
        channelTitle: "CantoMando",
        channelPk: 6139879,
        channelId: "UCX6J_d8wN4teUGjyVEcplSg"
    }
];



// WEBPACK FOOTER //
// ./src/InfoList/TourFakeData.js